var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9724_2929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 10.7433C5.99998 10.3764 5.99998 10.193 6.04143 10.0203C6.07817 9.86729 6.13878 9.72098 6.22102 9.58677C6.31378 9.43539 6.4435 9.30568 6.70293 9.04625L13.875 1.87419C14.4963 1.25287 15.5037 1.25287 16.125 1.87419C16.7463 2.49551 16.7463 3.50287 16.125 4.12419L8.95294 11.2963C8.69352 11.5557 8.5638 11.6854 8.41243 11.7782C8.27822 11.8604 8.1319 11.921 7.97885 11.9577C7.80622 11.9992 7.62277 11.9992 7.25589 11.9992H5.99998V10.7433Z",
    fill: "#DCEBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.99919H5.1C3.83988 2.99919 3.20982 2.99919 2.72852 3.24443C2.30516 3.46014 1.96095 3.80435 1.74524 4.22772C1.5 4.70902 1.5 5.33908 1.5 6.59919V12.8992C1.5 14.1593 1.5 14.7894 1.74524 15.2707C1.96095 15.694 2.30516 16.0382 2.72852 16.254C3.20982 16.4992 3.83988 16.4992 5.1 16.4992H11.4C12.6601 16.4992 13.2902 16.4992 13.7715 16.254C14.1948 16.0382 14.539 15.694 14.7548 15.2707C15 14.7894 15 14.1593 15 12.8992V9.74919M5.99998 11.9992H7.25589C7.62277 11.9992 7.80622 11.9992 7.97885 11.9577C8.1319 11.921 8.27822 11.8604 8.41243 11.7782C8.5638 11.6854 8.69352 11.5557 8.95294 11.2963L16.125 4.12419C16.7463 3.50287 16.7463 2.49551 16.125 1.87419C15.5037 1.25287 14.4963 1.25287 13.875 1.87419L6.70293 9.04625C6.4435 9.30568 6.31378 9.43539 6.22102 9.58677C6.13878 9.72098 6.07817 9.86729 6.04143 10.0203C5.99998 10.193 5.99998 10.3764 5.99998 10.7433V11.9992Z",
    stroke: "#0D3355",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9724_2929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.0c268de2.svg";
export { ForwardRef as ReactComponent };